<!-- 
 采用了particle.js粒子动画做背景 
 https://www.jianshu.com/p/c52b3e91c94f

  -->
<template>
  <div>
    <div class="particles-js-box">
      <div id="particles-js"></div>
    </div>
    <div class="report-card-content">
      <el-header class="head">
        <div class="shape-bg"></div>
        <div class="title">{{ title }}</div>
      </el-header>
      <main class="main">
        <el-card class="box-card">
          <!-- <header class="team-name">
            <div class="title">{{ title }}</div>
          </header> -->
          <el-form
            ref="teamForm"
            class="team-form"
            :model="teamObj"
            label-width="100px"
          >
            <el-form-item class="team-name-wrap" label="新建小组">
              <el-input class="team-name" v-model="newTeam"></el-input>
              <span class="cd-btn" @click="addTeam">确定</span>
            </el-form-item>
            <el-form-item label="小组列表">
              <el-select v-model="teamId" placeholder="请选择">
                <el-option
                  v-for="item in teamArr"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="students-section" label="小组成员">
              <span class="add-btn" @click="addStudent" title="添加成员"
                >+</span
              >
              <div class="student-list">
                <div
                  v-for="(student, index2) in teamObj.userInfos"
                  :key="index2"
                  class="student-wrap"
                >
                  <div
                    class="img-wrap"
                    @click="uploadAvatarActive('student', index2)"
                    @mouseover="showStudent(index2)"
                    @mouseleave="hideStudent(index2)"
                  >
                    <img
                      :src="
                        student.userPhoto
                          ? photoBaseUrl + student.userPhoto
                          : userPhoto
                      "
                      alt=""
                    />
                    <i
                      v-if="activeStuIndex == index2"
                      class="delete"
                      @click.stop="deleteStudent(index2)"
                      >×</i
                    >
                  </div>
                  <el-input
                    class="set-stu-name"
                    v-model="student.userName"
                    placeholder="姓名"
                  ></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item class="card-section" label="成绩单图">
              <span class="add-btn" @click="addCard" title="添加成绩单">+</span>
              <div class="report-card-list">
                <div
                  v-for="(card, index3) in teamObj.resultPhotos"
                  :key="index3"
                  class="card-wrap"
                >
                  <div
                    class="img-wrap"
                    @click="uploadAvatarActive('card', index3)"
                    @mouseover="showCard(index3)"
                    @mouseleave="hideCard(index3)"
                  >
                    <el-image :src="photoBaseUrl + card.resultPhoto">
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                    <!-- v-if="activeCardIndex == index3" -->
                    <i
                      v-if="activeCardIndex == index3"
                      class="delete"
                      @click.stop="deleteCard(index3)"
                      >×</i
                    >
                  </div>
                  <el-input
                    class="set-card-name"
                    v-model="card.photoName"
                    placeholder="成绩单名称"
                  ></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="小组成绩">
              <el-input
                class="teamScore-input"
                v-model="teamObj.teamScore"
              ></el-input>
            </el-form-item>
          </el-form>

          <el-footer>
            <span class="cd-btn" @click="saveTeam">保存</span>
          </el-footer>
        </el-card>
      </main>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import particlesJS from 'particles.js'
import particlesConfig from './particles.json'
//上传文件等公共接口
import COMMON from '@/axios/common/common.js'
import REPORT_CARD from '@/axios/reportCard/reportCard.js'

export default {
  name: 'CardManagement',
  data() {
    return {
      title: '成绩单管理系统',
      dialogVisible: false,
      teamArr: [],
      teamId: '',
      teamList: [
        {
          teamId: '1',
          name: '悟空组1',
          teamScore: 98,
          userInfos: [],
          resultPhotos: [
            {
              resultPhoto: require('../../../public/images/img03.png'),
            },
            {
              resultPhoto: require('../../../public/images/img04.png'),
            },
          ],
        },
      ],
      newTeam: '',
      teamObj: {
        newName: '',
        teamId: '1',
        name: '',
        teamScore: '',
        userInfos: [
          {
            userName: '张三',
            userPhoto: '',
          },
          {
            userName: '李四',
            userPhoto: '',
          },
        ],
        resultPhotos: [
          {
            resultPhoto: '',
            photoName: '',
          },
          {
            resultPhoto: '',
            photoName: '',
          },
        ],
      },
      userPhoto: require('../../../public/images/profile03.png'),
      studentObj: {},
      activeStuIndex: null,
      activeCardIndex: null,
      photoBaseUrl: window.gtaAiConfig.photoDomain, // 新UC头像基地址
    }
  },
  watch: {
    teamId(id) {
      this.getTeamInfoByTeamId()
    },
  },
  created() {
    // this.studentObj = this.userInfos[0]
    this.getTeam()
  },
  mounted() {
    this.initParticle()
  },
  methods: {
    initParticle() {
      window.particlesJS('particles-js', particlesConfig)
      // particlesJS('particles-js', particlesConfig)
      document.body.style.overflow = 'hidden'
    },
    addStudent() {
      let userPhoto = this.userPhoto
      let student = {
        name: '',
        userPhoto: '',
      }
      this.teamObj.userInfos.push(student)
    },
    addCard() {
      let userPhoto = this.userPhoto
      let card = {
        name: '',
        resultPhoto: '',
      }
      this.teamObj.resultPhotos.push(card)
    },
    showStudent(index) {
      this.activeStuIndex = index
    },
    hideStudent(index) {
      this.activeStuIndex = null
    },
    showCard(index) {
      this.activeCardIndex = index
    },
    hideCard(index) {
      this.activeCardIndex = null
    },
    deleteStudent(index) {
      this.teamObj.userInfos.splice(index, 1)
      this.$forceUpdate()
    },
    deleteCard(index) {
      this.teamObj.resultPhotos.splice(index, 1)
      this.$forceUpdate()
    },
    // 上传头像激活
    uploadAvatarActive(type, index) {
      let inputNode = this.inputFileVirtual(type, index)
      inputNode.click()
    },
    // 虚拟 input 上传
    inputFileVirtual(type, index) {
      // 1.创建一个上传节点
      let inputNode = document.createElement('input'),
        self = this

      // 文件上传按钮配置
      inputNode.setAttribute('type', 'file')
      inputNode.setAttribute('accept', 'image/*') // 限制图片除外的文件上传
      // 文件上传过程
      inputNode.onchange = function uploadImg(evt) {
        // 获取 file
        let file = evt.target.files[0],
          formdata = new FormData()
        formdata.append('file', file)
        COMMON.UploadFile(formdata)
          .then(async (result) => {
            if (result && result.returnCode == 200 && result.data) {
              let url = result.data.url
              //复制头像url
              if (type == 'student') {
                self.teamObj.userInfos[index].userPhoto = url
              } else if (type == 'card') {
                self.teamObj.resultPhotos[index].resultPhoto = url
              }
              console.log('self.teamObj', self.teamObj)
              this.$forceUpdate()
            }
          })
          .catch((err) => {})
      }

      return inputNode
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => {})
    },
    selectStudent(index) {
      // this.studentObj = this.userInfos[index]
    },
    /**
     *  增加/保存小组 @data teamName:小组名称
     */
    addTeam() {
      let teamName = '',
        data = {}
      if (!this.newTeam.trim()) return
      teamName = this.newTeam.trim()
      data.teamName = teamName
      REPORT_CARD.addTeam(data).then((res) => {
        if (res && res.returnCode == 200) {
          this.$message.success('添加小组成功！')
          this.getTeam()
        }
      })
    },
    /**
     *  增加/保存小组 @data teamName:小组名称
     */
    getTeam() {
      REPORT_CARD.getTeam().then((res) => {
        if (res && res.returnCode == 200) {
          this.teamArr = res.data
          if (this.teamArr.length > 0 && !this.teamId) {
            this.teamId = this.teamArr[0].value
          }
        }
      })
    },
    /**
     *  根据小组id获取小组信息 @data teamId 小组id
     */
    getTeamInfoByTeamId() {
      let { teamId } = this,
        data = { teamId }
      REPORT_CARD.getTeamInfoByTeamId(data).then((res) => {
        if (res && res.returnCode == 200) {
          this.teamObj = res.data
        } else if (res.returnMsg) {
          console.error('returnMsg', res.returnMsg)
        }
      })
    },
    /**
     *  保存数据 @data
     */
    saveTeam() {
      let { teamId, teamObj } = this
      teamObj.teamId = teamId
      REPORT_CARD.save(teamObj).then((res) => {
        if (res && res.returnCode == 200) {
          this.$message.success('该小组成绩单保存成功')
        } else if (res.returnMsg) {
          this.$message.error('该小组成绩单保存失败')
          console.error('returnMsg', res.returnMsg)
        }
      })
    },
  }, //methods end
}
</script>

<style lang="scss" scoped>
$main_bg: #061f3e;
$second_bg: rgba(4, 10, 18, 0.7);
$main_btn: rgb(0, 222, 255);
// $main_btn: #00deff;
$font_primary_color: #fff;
$font_second_color: #060e1a;
$border_main: rgba(0, 222, 255, 0.3);
.report-card-content {
  width: 1200px;
  height: 100%;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  .head {
    width: 100;
    margin: 10px auto;
    text-align: center;
    color: #fff;
    .title {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      color: #fff;
      z-index: 999;
      margin-top: 10px;
      font-size: 28px;
    }
  }
  .shape-bg {
    position: absolute;
    content: '';
    position: absolute;
    width: 560px;
    height: 0;
    border-top: 60px solid #10254b;
    border-right: 30px solid transparent;
    border-left: 30px solid transparent;
    left: 50%;
    transform: translateX(-50%);
    color: #fff;
  }

  .main {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 20px;
    display: flex;
    justify-content: start;
    flex-wrap: wrap;
    // align-items: center;

    .team-name {
      width: 100%;
      margin: 10 auto;
      text-align: center;
      // border-bottom: 1px solid $main_btn;
    }
    ::v-deep .box-card {
      width: 100%;
      height: 86%;
      box-sizing: border-box;
      // padding-bottom: 20px;
      overflow-y: auto;
      min-width: 800px;
      max-width: 1200px;
      margin: 10px 10px;
      background: $second_bg;
      color: $font_primary_color;
      border: 1px solid $border_main;
      .el-card__body {
        padding: 0;
      }
    }
  }
  .el-footer {
    width: 100%;
    padding-top: 15px;
    position: absolute;
    bottom: 80px;
  }
  .cd-btn {
    display: block;
    width: 200px;
    height: 44px;
    background: url('../../../public/images/titBg.png');
    background-size: 100% 100%;
    line-height: 44px;
    text-align: center;
    font-size: 18px;
    color: #00deff;
    margin: 0 auto;
    cursor: pointer;
  }
}

.particles-js-box {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1; //这里建议层级设为-1，但-1可能会导致被其他元素遮挡
}
#particles-js {
  background-color: $main_bg;
  width: 100%;
  height: 100%;
}
::v-deep .el-form.team-form {
  .el-form-item {
    &.team-name-wrap {
      padding: 15px 0 15px 0;
      border-bottom: 1px solid $border_main;
      .el-form-item__content {
        display: flex;
        justify-content: start;
        .team-name {
          width: 50%;
        }
        .cd-btn {
          margin-left: 20px;
        }
      }
    }
    .el-form-item__label {
      color: $font_primary_color;
    }
    .el-form-item__content {
      // max-width: 300px;
      .el-input {
        color: $font_primary_color;
        &.teamScore-input {
          width: 210px;
        }
        .el-input__inner {
          background: rgba(255, 255, 255, 0.1);
          color: $font_primary_color;
          border: none;
        }
      }
    }

    &.students-section {
      height: 132px;
    }
    .student-list {
      width: 96%;
      height: 100%;
      min-height: 80px;
      display: flex;
      justify-content: start;
      flex-wrap: nowrap;
      padding: 10px 0 0 10px;
      overflow-x: auto;
      @include scroll-bar(2px);
      .student-wrap {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 0 10px;
        .img-wrap {
          height: 44px;
          img {
            width: 44px;
            height: 44px;
            border-radius: 22px;
          }
          .delete {
            font-size: 20px;
            position: absolute;
            transform: translate(-7px, 0px);
            z-index: 10;
            color: red;
            font-size: 14px;
            font-weight: 600;
            width: 16px;
            height: 16px;
            line-height: 16px;
            border-radius: 8px;
            text-align: center;
            background: $main_btn;
            cursor: pointer;
          }
        }
        .set-stu-name {
          width: 80px;
          .el-input__inner {
            border: none;
            text-align: center;
            height: 30px;
            line-height: 30px;
          }
        }
      }
    }
    &.card-section {
      height: 220px;
    }
    .report-card-list {
      // width: 100%;
      height: 100%;
      display: flex;
      justify-content: start;
      flex-wrap: nowrap;
      overflow-x: auto;
      @include scroll-bar(2px);
      padding: 10px 0 0 10px;
      .card-wrap {
        margin: 0 10px 10px 0px;
        flex-shrink: 0;
        .img-wrap {
          width: 100%;
          height: 120px;
          background: rgba(255, 255, 255, 0.1);
          content: '+';
          color: $font_primary_color;
          display: flex;
          // justify-content: center;
          // align-items: center;
          cursor: pointer;
          position: relative;
          .el-image {
            width: 100%;
            height: 100%;

            .el-icon-picture-outline {
              text-align: center;
              margin: 20px auto;
              position: absolute;
              left: 50%;
              top: 35%;
              transform: translate(-50%, -50%);
              &::before {
                font-size: 30px;
              }
            }
          }
          .delete {
            font-size: 20px;
            position: absolute;
            right: -5px;
            margin-top: -5px;
            z-index: 10;
            color: red;
            font-size: 14px;
            font-weight: 600;
            width: 16px;
            height: 16px;
            line-height: 16px;
            border-radius: 8px;
            text-align: center;
            background: $main_btn;
            cursor: pointer;
          }
        }
        .set-card-name {
          display: block;
          text-align: center;
        }
        .el-input__inner {
          text-align: center;
        }
        // .el-input__inner{
        //   text-align: center;
        // }
      }
    }
  }
  // .students-section{

  // }
  .add-btn {
    display: block;
    width: 36px;
    height: 36px;
    line-height: 36px;
    border-radius: 18px;
    background: $main_btn;
    color: $font_second_color;
    font-weight: 500;
    text-align: center;
    font-size: 36px;
    cursor: pointer;
  }
}
</style>
